import { 
    ADD_ALERT,
    ADD_CAR_DETAIL,
    FETCH_ALL_CAR_DETAILS,
    UPDATE_CAR_DETAIL,
    DELETE_CAR,
    SEARCH_CARS
} from './types';
import shortId from "shortid";
import sleektrading from "../apis/sleektrading"

export const addCarDetail = (values) => dispatch => {
    sleektrading.post('/cars/create', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: ADD_CAR_DETAIL,
                    payload: response.data.data
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const fetchAllCarDetails= (pageNumber) => async dispatch => {
    const {data} = await sleektrading.post(`/cars/index?page=${pageNumber}`);
    
    if(data.code == 201){
        dispatch({
            type: FETCH_ALL_CAR_DETAILS,
            payload: data.data
        });
    }
}

export const updateCarDetail = (values) => dispatch => {
    sleektrading.post('/cars/edit', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: UPDATE_CAR_DETAIL,
                    payload: response.data.data
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const deleteCar= (car_detail_id) => async dispatch => {
    sleektrading.post('/cars/delete', {car_detail_id})
    .then(response => {
        if(response.data.code == 200) {
            dispatch({
                type:DELETE_CAR, 
                payload:car_detail_id
            });
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        } else {
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        }
    }).catch(error => {
        dispatch({
            type:ADD_ALERT,
            payload:{
            key:shortId.generate(),
            status:'error',
            message:error.response.data.message,
            errors:error.response.data.errors
        }
    });
    });
}

export const searchCars = (values) => dispatch => {
    sleektrading.post('/cars/search', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: SEARCH_CARS,
                    payload: response.data.data
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

